import { draPartnerId, partnerId } from "api/Consts";
import React from "react";

export default ({ className, children }) => {
  return (
    <div
      className={`${
        draPartnerId === partnerId ? "" : "px-4 pt-3"
      } xl:px-0 lg:max-w-7xl lg:mx-auto  ${className} relative z-0`}
    >
      {children}
    </div>
  );
};
